// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { put } from 'redux-saga/effects';

import {
    saveCustomerCommentsSuccess, SAVE_CUSTOMER_COMMENTS
} from './../../../store/orderCreation';
import {
    actionStatusStarted,
    actionStatusFailed,
    actionStatusSuccess,
} from './../../../store/actionStatus';

export function* saveCustomerComment(request: any): IterableIterator<any> {
    try {
        yield put(
            actionStatusStarted({
                actionName: SAVE_CUSTOMER_COMMENTS,
            })
        );

        yield put(saveCustomerCommentsSuccess(request.payload));

        yield put(
            actionStatusSuccess({
                actionName: SAVE_CUSTOMER_COMMENTS,
            })
        );
    } catch (e) {
        yield yield put(
            actionStatusFailed({
                actionName: SAVE_CUSTOMER_COMMENTS,
                error: e,
            })
        );
    }
}
